// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    export enum CostReviewType {
  None = 0,
  AutomationEnUs = 1,
  FireEnUs = 2,
  SecurityEnUs = 3,
  ServiceAgreementEnUs = 4,
  ElectricalEnUs = 5,
  MechanicalEnUs = 6,
}
